import { useCallback } from 'react';
import { Compare } from './components/Compare';
import { Contact } from './components/Contact';
import { Faqs } from './components/Faqs';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Legacy } from './components/Legacy';
import { Nav } from './components/Nav';
import { People } from './components/People';
import { Flow } from './content/site';
import { useFlow } from './hooks/useFlow';
import './styles/tokens.css';
import './styles/base.css';

export default function App() {
  const { flow, setFlow, flowKey } = useFlow();

  /** Choosing a route sets the flow and takes the visitor to the form. */
  const chooseFlow = useCallback(
    (next: Flow) => {
      setFlow(next);
      document
        .getElementById('enquire')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    [setFlow],
  );

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Nav />
      <main id="main">
        <Hero flowKey={flowKey} onChoose={chooseFlow} />
        <Legacy />
        <People />
        <HowItWorks flow={flow} onChange={setFlow} />
        <Compare flow={flow} onChoose={chooseFlow} />
        <Faqs />
        <Contact flowKey={flowKey} onChangeFlow={setFlow} />
      </main>
      <Footer onChoose={setFlow} />
    </>
  );
}
